
const contactInfo = [
  {
    icon: 'ri-phone-line',
    label: '電話',
    value: '0908-162292',
    link: 'tel:0908-162292'
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: '2019oceandreamer@gmail.com',
    link: 'mailto:2019oceandreamer@gmail.com'
  }
];

const socialLinks = [
  {
    icon: 'ri-global-line',
    label: '活動頁面官方網站',
    link: 'https://www.ocean5min.com/'
  },
  {
    icon: 'ri-instagram-line',
    label: '離海5min b&b IG',
    link: 'https://www.instagram.com/5min_to_sea_bnb/'
  },
  {
    icon: 'ri-facebook-fill',
    label: '離海5min b&b FB',
    link: 'https://www.facebook.com/people/%E9%9B%A2%E6%B5%B75min-bb/61559543212238/'
  },
  {
    icon: 'ri-instagram-line',
    label: '離海5min IG',
    link: 'https://www.instagram.com/5min_to_sea/'
  },
  {
    icon: 'ri-facebook-fill',
    label: '離海5min FB',
    link: 'https://www.facebook.com/oceandreamer2019/?locale=zh_TW'
  }
];

export default function Contact() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">聯絡我們</h2>
          <p className="text-xl text-gray-600">歡迎隨時與我們聯繫</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Contact Info */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">聯絡資訊</h3>
              <div className="space-y-4">
                {contactInfo.map((info, idx) => (
                  <a
                    key={idx}
                    href={info.link}
                    className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg hover:bg-teal-50 transition-colors cursor-pointer group"
                  >
                    <div className="w-12 h-12 bg-teal-100 group-hover:bg-teal-500 rounded-full flex items-center justify-center transition-colors">
                      <i className={`${info.icon} text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-600">{info.label}</p>
                      <p className="text-lg font-semibold text-gray-900">{info.value}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Social Links */}
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">更多資訊</h3>
              <div className="space-y-3">
                {socialLinks.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-teal-50 transition-colors cursor-pointer group"
                  >
                    <div className="w-10 h-10 bg-teal-100 group-hover:bg-teal-500 rounded-full flex items-center justify-center transition-colors">
                      <i className={`${social.icon} text-xl text-teal-600 group-hover:text-white transition-colors`}></i>
                    </div>
                    <span className="text-gray-700 group-hover:text-teal-700 font-medium transition-colors">
                      {social.label}
                    </span>
                    <i className="ri-external-link-line ml-auto text-gray-400 group-hover:text-teal-500 transition-colors"></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gradient-to-r from-teal-500 to-blue-500 rounded-2xl p-12 text-center text-white shadow-xl">
            <h3 className="text-3xl font-bold mb-4">準備好開始您的旅程了嗎？</h3>
            <p className="text-xl mb-8 opacity-90">立即預訂，享受美好的海邊假期</p>
            <a
              href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-10 py-4 bg-white hover:bg-gray-100 text-teal-600 font-bold text-lg rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              立即預訂
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
